import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquidialog',
	templateUrl:'./JQUIDialogPluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIDialogPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDialogPluginCompPage
{
	mdContent_1011 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.dialog.JQUIDialog;
\`\`\``;
	mdContent_1012 = `\`\`\`java
JQUIDialog()
\`\`\``;
	mdContent_1013 = `\`\`\`java
JQUIDialog(String title)
\`\`\``;
	mdContent_1014 = `\`\`\`java
JQUIDialog&lt;?&gt; dialog = new JQUIDialog&lt;&gt;("Confirm");
dialog.getOptions().setModal(true);
dialog.getOptions().setWidth(400);
dialog.getOptions().setHeight(300);
dialog.add(new Paragraph&lt;&gt;().setText("Are you sure?"));
\`\`\``;
}
